export enum SurveyStatus {
  Draft = 'Draft',
  Open = 'Open',
  Closed = 'Closed',
}

export enum VoteAudience {
  BoardMembers = 'BoardMembers',
  CommunityMembers = 'CommunityMembers',
}

export enum VoteQuestionType {
  YesNo = 'YesNo',
  MultipleChoice = 'MultipleChoice',
  FreeText = 'FreeText',
}

export type SurveyListFilter = {
  statuses?: SurveyStatus[];
  audiences?: VoteAudience[];
  currentPage?: number;
  pageSize?: number;
};
